import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconGear, IconX, IconCheck } from "../../components/Icons";

const FAQS = [
  {
    question: "O que é um MSP e por que contratar?",
    answer:
      "MSP (Managed Service Provider) é um parceiro que assume a responsabilidade pela gestão contínua de TI da sua empresa. Em vez de pagar por chamado quando algo quebra, você tem monitoramento, prevenção e suporte incluídos em uma mensalidade fixa.",
  },
  {
    question: "Preciso ter alguma estrutura de TI antes?",
    answer:
      "Não necessariamente. A sepolTECH realiza um diagnóstico inicial da sua infraestrutura e define, junto com você, as prioridades de implantação e melhoria.",
  },
  {
    question: "A sepolTECH substitui um funcionário de TI interno?",
    answer:
      "Sim, na maioria dos casos. Para PMEs que não têm — e não precisam ter — um TI interno em tempo integral, a sepolTECH entrega mais cobertura com custo previsível e equipe especializada.",
  },
  {
    question: "Como funciona o suporte ilimitado?",
    answer:
      "Você abre chamado pelo portal, e-mail ou telefone. Nossa equipe atende remotamente na maioria dos casos. Para situações presenciais em SP, agendamos visita. Sem limite de chamados e sem cobrança extra.",
  },
];

const FEATURES = [
  {
    title: "Monitoramento Proativo 24/7",
    desc: "Rastreamos sua infraestrutura em tempo real e agimos antes que problemas virem incidentes",
  },
  {
    title: "Gestão de Infraestrutura",
    desc: "Servidores, redes, estações — tudo inventariado, atualizado e funcionando",
  },
  {
    title: "Suporte Ilimitado",
    desc: "Chamados ilimitados sem custo extra, atendidos remotamente ou presencialmente em SP",
  },
  {
    title: "Gestão de Patches & Updates",
    desc: "Atualizações de segurança aplicadas sistematicamente, sem risco para a operação",
  },
  {
    title: "Relatórios Mensais",
    desc: "Relatório mensal com o status da infraestrutura, incidentes e melhorias realizadas",
  },
  {
    title: "Planejamento de TI",
    desc: "Planejamos com você a evolução tecnológica da empresa — sem improvisação",
  },
];

export default function GestaoTI() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/servicos/servicos">Serviços</Link>
            <span>/</span>
            <span>Gestão de TI</span>
          </div>
          <div className="tag animate-up animate-up--d1">
            <IconGear style={{ width: "13px", height: "13px" }} />
            MSP Core · Managed Service Provider
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(36px,5vw,64px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.1",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            Gestão de TI
            <br />
            <span className="text-blue">
              Seu departamento terceirizado
            </span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "560px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Contrate a sepolTECH como seu departamento de TI completo.
            Monitoramento proativo, gestão de infraestrutura e suporte
            ilimitado — por uma mensalidade fixa, sem surpresas.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Solicitar proposta →
            </Link>
            <Link to="/servicos/servicos" className="btn btn-outline">
              Ver todos os serviços
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ O QUE ESTÁ INCLUSO ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col">
            <Reveal>
              <div className="tag">O que está incluso</div>
              <h2 className="section-title" style={{ marginBottom: "28px" }}>
                O que a sepolTECH <span className="text-blue">entrega</span>
              </h2>
              <div className="feature-list">
                {FEATURES.map((f) => (
                  <div className="feature-item" key={f.title}>
                    <div
                      className="feature-item__icon"
                      style={{ background: "rgba(0,102,255,.15)", color: "#0066FF" }}
                    >
                      ✓
                    </div>
                    <div>
                      <strong style={{ color: "var(--text-primary)" }}>
                        {f.title}
                      </strong>{" "}
                      — {f.desc}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "16px" }}
              >
                <div
                  style={{
                    background: "rgba(239,68,68,.05)",
                    border: "1px solid rgba(239,68,68,.2)",
                    borderRadius: "var(--radius-lg)",
                    padding: "28px",
                  }}
                >
                  <h3
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      color: "var(--error)",
                      fontSize: "15px",
                      fontWeight: 700,
                      marginBottom: "14px",
                    }}
                  >
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        background: "rgba(239,68,68,.15)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <IconX style={{ width: "12px", height: "12px" }} />
                    </span>
                    Sem gestão de TI
                  </h3>
                  <ul
                    style={{ display: "flex", flexDirection: "column", gap: "8px" }}
                  >
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Problemas só descobertos quando param tudo
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Custos imprevisíveis por chamado emergencial
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Nenhuma visibilidade sobre o ambiente
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Segurança negligenciada por falta de tempo
                    </li>
                  </ul>
                </div>
                <div
                  style={{
                    background: "rgba(34,197,94,.05)",
                    border: "1px solid rgba(34,197,94,.2)",
                    borderRadius: "var(--radius-lg)",
                    padding: "28px",
                  }}
                >
                  <h3
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      color: "var(--success)",
                      fontSize: "15px",
                      fontWeight: 700,
                      marginBottom: "14px",
                    }}
                  >
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        background: "rgba(34,197,94,.15)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <IconCheck style={{ width: "12px", height: "12px" }} />
                    </span>
                    Com sepolTECH MSP
                  </h3>
                  <ul
                    style={{ display: "flex", flexDirection: "column", gap: "8px" }}
                  >
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Problemas detectados e resolvidos antes de afetar você
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Mensalidade fixa — sem surpresas financeiras
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Relatórios e visibilidade total do ambiente
                    </li>
                    <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                      Segurança gerenciada e atualizada continuamente
                    </li>
                  </ul>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "780px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag">FAQ</div>
            <h2 className="section-title">Dúvidas frequentes</h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.05}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              Pronto para ter TI
              <br />
              que funciona de verdade?
            </h2>
            <p className="cta-banner__sub">
              Fale com nossa equipe e receba uma proposta de Gestão de TI
              para a sua empresa.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Solicitar proposta MSP →
              </Link>
              <Link to="/servicos/servicos" className="btn btn-outline">
                Ver todos os serviços
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
